// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-group__textarea[data-v-eb0bc060]{display:block;width:100%;font-size:18px;border:none;border-bottom:1px solid #d8d8d8;color:#000;padding:12px 0;margin:0;outline:none}.form-group__textarea[data-v-eb0bc060]:focus{border-color:#000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
